import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../contexts/TranslationContext';

const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className="bg-gray-800 text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-3">
                    {/* Company Info */}
                    <div className="col-span-1 md:col-span-2">
                        <div className="flex items-center mb-1">
                            <div className="w-8 h-8 flex items-center justify-center mr-2">
                                <img
                                    src="/favicon.ico"
                                    alt="Sunsite Logo"
                                    className="w-full h-full object-contain"
                                />
                            </div>
                            <span className="text-base font-bold">
                                <span className="text-yellow-400">Sun</span>
                                <span className="text-white">site</span>
                            </span>
                        </div>
                        <p className="text-gray-300 mb-1 text-xs leading-relaxed">
                            {t('footer.description')}
                        </p>
                        <div className="space-y-0.5">
                            <div className="flex items-center text-gray-300 text-xs">
                                <div className="w-4 h-4 flex items-center justify-center mr-3 flex-shrink-0">
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                </div>
                                <span>info@sunsite.it</span>
                            </div>
                            <div className="flex items-center text-gray-300 text-xs">
                                <div className="w-4 h-4 flex items-center justify-center mr-3 flex-shrink-0">
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                    </svg>
                                </div>
                                <span>+39 348 929 2344</span>
                            </div>
                            <div className="flex items-center text-gray-300 text-xs">
                                <div className="w-4 h-4 flex items-center justify-center mr-3 flex-shrink-0">
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                </div>
                                <span>Duka straße 2, 39042 Brixen</span>
                            </div>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-base font-bold text-white mb-2">{t('footer.navigation')}</h3>
                        <ul className="space-y-0.5">
                            <li>
                                <Link to="/" className="text-gray-300 hover:text-white transition-colors duration-200 block py-0.5 text-xs">
                                    {t('header.home')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors duration-200 block py-0.5 text-xs">
                                    {t('header.contact')}
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Legal */}
                    <div>
                        <h3 className="text-base font-bold text-white mb-2">{t('footer.legal')}</h3>
                        <ul className="space-y-0.5">
                            <li>
                                <Link to="/impressum" className="text-gray-300 hover:text-white transition-colors duration-200 block py-0.5 text-xs">
                                    {t('footer.impressum')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/datenschutz" className="text-gray-300 hover:text-white transition-colors duration-200 block py-0.5 text-xs">
                                    {t('footer.datenschutz')}
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-700 mt-3 pt-3">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <p className="text-gray-400 text-xs">
                            {t('footer.copyright')}
                        </p>
                        <div className="flex items-center space-x-6 mt-1 md:mt-0">
                            <span className="text-gray-400 text-xs">{t('footer.slogan')}</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
